import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { ESPORTS_INDEX_QUERY } from 'embroil/gql/queries/esports-index';
export default class Esports extends Route {
  query = useQuery(this, () => [ESPORTS_INDEX_QUERY]);

  async model() {
    try {
      await this.query.promise;
      
      return {
        articles: this.query.data.articles,
        popularPosts: this.query.data.popularPosts || []
      };
    } catch (error) {
      console.error('Error loading esports:', error);
      return {
        articles: [],
        popularPosts: []
      };
    }
  }
}
